import { useTranslation } from 'react-i18next';
import { usePiecesPerBundleUnit } from '~/hooks/usePiecesPerBundleUnit';
import type { ItemRow, ProductGroup } from '~/pages/rfq-view/itemGroups';
import { requestedQuantityInStandardUnits } from './quoteDisplay';

const DETAIL_CLASS = 'text-xs font-normal text-neut-sec';

export function ProductLengthDetails({
  group,
  row,
  requestedBundles,
}: Readonly<{
  group: ProductGroup;
  row: ItemRow;
  requestedBundles: number | null;
}>) {
  const { t } = useTranslation('rfq-view');
  const piecesPerBundleUnit = usePiecesPerBundleUnit();
  const productDetails = [
    group.productCode,
    row.piecesPerBundle > 0
      ? `${row.piecesPerBundle} ${piecesPerBundleUnit}`
      : null,
  ]
    .filter(Boolean)
    .join(' · ');
  const requestedQuantity = requestedQuantityInStandardUnits(
    row,
    group.standardUnitsCode
  );

  return (
    <>
      <span>
        {group.productName} — {row.displayValue}
      </span>
      {productDetails && <span className={DETAIL_CLASS}>{productDetails}</span>}
      {requestedBundles != null && (
        <span className={DETAIL_CLASS}>
          {t('rfq_view.requested_quantity_label', {
            count: requestedBundles,
          })}
        </span>
      )}
      {requestedQuantity && (
        <span className={DETAIL_CLASS}>{requestedQuantity}</span>
      )}
    </>
  );
}
